import React, { useState, useEffect, useContext} from 'react';
import { Box, TextField, Typography, Button, Stack, Select, MenuItem, Table, TableBody, TableCell, TableRow, FormControl, InputLabel } from '@mui/material';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, Link, useParams } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import AuthContext from '../../contexts/AuthContext';
import { setSnackDetails, setMetaData, setSweetAlert } from '../../service/actions/common';
import axios from 'axios';
import { setAdminUserData } from '../../service/actions/index';

import { useFormik } from 'formik';
import * as yup from 'yup';
const validationSchema = yup.object({
    full_name: yup
        .string('Enter Full Name')
        .required('Full Name is required'),
    email: yup
        .string('Enter your email')
        .matches(/^[^@\s]+@[^@\s]+\.[^@\s]+$/, 'Enter a valid email')
        .required('Email is required'),    
    });

const AdminUsersProfile = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    let { userId } = useParams();
    const { token, user } = useContext(AuthContext);
    const formatOptions = JSON.parse(process.env.REACT_APP_DATE_TIME_FORMAT || '{}');
    const [formated_last_active, setLastAct] = useState('');
    let metaData = useSelector((state) => state.metaData); 
    const catchError = async (error) => {
        if (error.response) {
            if (error.response.status === 401) {
                navigate('/sign-in');
            } else if (error.response.status >= 500) {
                dispatch(setSweetAlert({ open: true, title: 'Server Error', text: '' }));
            } else if (error.response.status === 400) {
                dispatch(setSnackDetails({openState : true, message : error.response.data.message, severity : 'error'}));
                return false;
            } else {
                dispatch(setSweetAlert({ open: true, title: 'Error', text: '' }));
            }
        } else if (error.request) {
            dispatch(setSweetAlert({ open: true, title: 'Connection Lost', text: '' }));
        } else {
            dispatch(setSweetAlert({ open: true, title: 'Error', text: 'An unknown error occurred.' }));
        }
    };

    const fetchUser = async () => {        
        if (user && token) {
            try {
                let uri = `/user/${userId}`;
                const response = await axios.get(uri, {
                    headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    },
                });
                const admin_user = response.data.user;
                dispatch(setAdminUserData(admin_user));
                const last_active = Date.parse(admin_user.last_active);
                const temp_last_active =  new Intl.DateTimeFormat('en-US', formatOptions).format(last_active);
                setLastAct(temp_last_active);
                metaData  = {
                    title: `Admin Users | ${admin_user?.email}`,
                    description: `Admin Users | ${admin_user?.email}`
                };
                dispatch(setMetaData(metaData));
            } catch (error) {
                catchError(error);
            }
        }
      };
    useEffect(() => {
        fetchUser();
        // eslint-disable-next-line
    }, []);

    const [isEdit, setIsEdit] = useState(false);
    const profile = useSelector((state) => state.adminUserData);
    const formik = useFormik({
        initialValues: {
            user_id: profile?._id,
            full_name: profile?.full_name,
            email: profile?.email,
            status: profile?.status
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
        onSubmit: async (values) => {
            try {
                if (user && token ) {
                    const response = await axios.post('/user/update-profile', values, {
                        headers: {
                            'Authorization': `Bearer ${token}`
                        },
                    });
                    if (response.status === 200) {
                        dispatch(setAdminUserData(response.data.user));
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'success'}));
                        setIsEdit(false);
                    } else {
                        dispatch(setSnackDetails({openState : true, message : response.data.message, severity : 'error'}));
                    }
                } else {
                    console.log('unauthorized');
                }
            } catch (error) {
                catchError(error);
            }
        },
    });

  return (
    <Box>
        <Stack direction="row" justifyContent="flex-start" sx={{ width: '100%' }}>
            <Button component={Link} to="/admin-users">
                <ArrowBackIcon />
            </Button>
            <Typography variant="h4">{profile?.full_name}</Typography>
            { isEdit ? (
            <Button color="primary" variant="contained" onClick={formik.handleSubmit} sx={{ borderRadius: 28, ml: "auto" }} >
                Save
            </Button>
            ) : (
            <Button color="primary" variant="outlined" onClick={(e) => {setIsEdit(true)}} sx={{ borderRadius: 28, ml: "auto" }} >
                Edit
            </Button>
            )}

        </Stack>
        <Box
            sx={{
                margin: 'auto',
                padding: 2,
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                border: '1px solid #ddd',
                borderRadius: 2,
                boxShadow: 1,
                mt:2,
                backgroundColor:'#FFF'
            }}
        >
            <Typography variant="h4" gutterBottom>
                About
            </Typography>
            
        { isEdit ? (
        <Stack direction="column" justifyContent="center" spacing={2} sx={{ width: '40%' }}>
            <TextField
                label="Full Name"
                name="full_name"
                id="full_name"
                type="text"
                required
                autoFocus
                value={formik.values.full_name}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.full_name && Boolean(formik.errors.full_name)}
                helperText={formik.touched.full_name && formik.errors.full_name}
            />
            <TextField
                label="Email"
                name="email"
                id="email"
                type="text"
                required
                value={formik.values.email}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                error={formik.touched.email && Boolean(formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
            />
            <FormControl fullWidth variant="outlined" error={formik.touched.status && Boolean(formik.errors.status)}>
                <InputLabel id="status-label">Status</InputLabel>
                <Select
                    id="status"
                    name="status"
                    label="Status"
                    labelId="status-label" 
                    fullWidth
                    value={formik.values.status || 0}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                >
                    <MenuItem value={1}>Active</MenuItem>
                    <MenuItem value={0}>Inactive</MenuItem>
                </Select>
            </FormControl>
        </Stack>
        ) : (
            <Stack direction="column" justifyContent="center" spacing={2} sx={{ width: '40%', ml:3, mt:2 }}>
                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Name</Typography>
                <Typography variant="p">{profile?.full_name}</Typography>

                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Email</Typography>
                <Typography variant="p">{profile?.email}</Typography>

                <Typography variant="p" sx={{ fontWeight: 'bold' }}>Status</Typography>
                <Typography variant="p">{profile?.status === 1 ? 'Active' : 'Inactive'}</Typography>
            </Stack>
        )}
    </Box>


        <Box
        sx={{
            margin: 'auto',
            padding: 2,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            border: '1px solid #ddd',
            borderRadius: 2,
            boxShadow: 1,
            mt:2,
            backgroundColor:'#FFF'
        }}
        >
            <Typography variant="h5" gutterBottom>Stats</Typography>
            <Table sx={{ width: '50%' }} aria-label="simple table">                
                <TableBody>
                        <TableRow sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                            <TableCell sx={{ fontWeight: 'bold' }} align="left">Last Active</TableCell>
                            <TableCell align="left" sx={{ color: 'primary.main' }}>{formated_last_active}</TableCell>
                        </TableRow>
                </TableBody>
            </Table>
        </Box>
    </Box>
  );
};

export default AdminUsersProfile;